import { CreatePaymentResponse } from '@unitedtraders/utcom-api-sdk';
import { AxiosResponse } from 'axios';
import { v4 as uuid } from 'uuid';
import url from 'url';
import { useUtcomApi } from './useUtcomApi';
import { useHistory } from './useHistory';

export interface FormValues {
  amount: number;
}

export const useSubmit = (paymentSystemId: number | undefined, currency: 'USD' | 'RUB') => {
  const history = useHistory();
  const utcomApi = useUtcomApi();

  return {
    onSubmit: async (values: FormValues) => {
      if (!paymentSystemId) {
        throw new Error("Can't query payeer paymentSystemId");
      }

      const siteUrl = `${window.location.origin}${history.createHref(history.location)}`;

      const { data }: AxiosResponse<CreatePaymentResponse> =
        await utcomApi.depositService.createPayment({
          requestId: uuid(),
          amount: { value: values.amount, currency },
          successUrl: `${siteUrl}success`,
          failureUrl: `${siteUrl}failure`,
          paymentSystemId,
        });

      const paymentSystem = data.allowedPaymentSystems.find(
        (system) => system.id === paymentSystemId
      );

      if (!paymentSystem) {
        throw new Error('No paymentSystem in allowedPaymentSystems response');
      }

      if (typeof window !== 'undefined') {
        window.location.href = url.format({
          pathname: paymentSystem?.url,
          query: Object.assign(
            {},
            ...paymentSystem.params!.map(({ key, value }) => ({ [key]: value }))
          ),
        });
      }
    },
  };
};
